/* Complement au panier « Pairs well with » (03/11/2026, Robin).
   Chaque unite a sa couleur : un toucher sur une pastille ajoute une unite de cette couleur
   (compteur sur la pastille) ; au-dela de la quantite du lot, la plus ancienne sort.
   « + Add » ajoute le tout en un appel, puis rejoue cart:update comme bfcm-gifts.js
   (le tiroir se redessine, les cadeaux se recalent). */
(function () {
  if (window.__bisousComplements) return;
  window.__bisousComplements = true;

  var picks = new WeakMap();

  /* Test 50/50 : groupe tiré une fois par navigateur (cookie 60 jours). ?bcc=A ou ?bcc=B force le groupe (aperçu). */
  var COOKIE = 'bcc_ab';
  function readCookie() {
    var m = document.cookie.match(/(?:^|; )bcc_ab=([AB])/);
    return m ? m[1] : null;
  }
  function writeCookie(v) {
    document.cookie = COOKIE + '=' + v + '; path=/; max-age=' + 60 * 24 * 3600 + '; SameSite=Lax';
  }
  function bucket(share) {
    var forced = (location.search.match(/[?&]bcc=([AB])/) || [])[1];
    if (forced) { writeCookie(forced); return forced; }
    var b = readCookie();
    if (!b) { b = Math.random() * 100 < share ? 'A' : 'B'; writeCookie(b); }
    return b;
  }

  var tagged = null;
  function testState() {
    var mark = document.querySelector('[data-bcc-mark]');
    if (!mark) return;
    var share = parseInt(mark.dataset.share, 10) || 0;
    var b = bucket(share);
    var show = share >= 100 || (share > 0 && b === 'A');
    Array.prototype.slice.call(document.querySelectorAll('[data-bcc]')).forEach(function (el) {
      if (el.classList.contains('is-shown') !== show) el.classList.toggle('is-shown', show);
    });
    /* Étiquette cachée sur le panier (reportée sur la commande), une fois par page et par groupe. */
    if (share > 0 && share < 100 && tagged !== b) {
      tagged = b;
      fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if ((cart.attributes || {})._bcc_test === b) return;
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: { _bcc_test: b } })
          });
        })
        .catch(function () { tagged = null; });
    }
  }

  function swatches(row) { return Array.prototype.slice.call(row.querySelectorAll('.bcc__sw')); }

  function initial(row) {
    var qty = parseInt(row.dataset.qty, 10) || 1;
    var avail = swatches(row).map(function (b) { return b.dataset.color; });
    var want = [];
    try { want = JSON.parse(row.dataset.picks || '[]') || []; } catch (e) { want = []; }
    want = want.filter(function (c) { return avail.indexOf(c) > -1; });
    if (!want.length) want = avail.slice(0, 1);
    var out = [];
    for (var i = 0; i < qty && want.length; i++) out.push(want[i % want.length]);
    return out;
  }

  function get(row) {
    if (!picks.has(row)) picks.set(row, initial(row));
    return picks.get(row);
  }

  /* N'ecrit que si le texte change : l'observateur plus bas ne doit pas se relancer lui-meme. */
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }

  function paint(row) {
    var list = get(row);
    var counts = {};
    list.forEach(function (c) { counts[c] = (counts[c] || 0) + 1; });
    swatches(row).forEach(function (b) {
      var n = counts[b.dataset.color] || 0;
      b.classList.toggle('is-on', n > 0);
      b.setAttribute('aria-pressed', n > 0 ? 'true' : 'false');
      setText(b.querySelector('.bcc__n'), n > 1 ? String(n) : '');
    });
    /* La photo suit la derniere couleur choisie. */
    var last = row.querySelector('.bcc__sw[data-color="' + (list[list.length - 1] || '').replace(/"/g, '\\"') + '"]');
    var img = row.querySelector('.bcc__img');
    if (last && last.dataset.img && img && img.getAttribute('src') !== last.dataset.img) img.setAttribute('src', last.dataset.img);
    var sel = row.querySelector('.bcc__sel');
    if (sel) {
      setText(sel, Object.keys(counts).map(function (c) {
        return counts[c] > 1 ? counts[c] + ' × ' + c : c;
      }).join(' · '));
    }
  }

  function paintAll(root) {
    testState();
    Array.prototype.slice.call((root || document).querySelectorAll('[data-bcc-row]')).forEach(paint);
  }

  function sectionIds() {
    return Array.prototype.slice.call(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map(function (el) { return el.dataset.sectionId; }).filter(Boolean);
  }

  function add(row, btn) {
    var bySw = {};
    swatches(row).forEach(function (b) { bySw[b.dataset.color] = b.dataset.variant; });
    var counts = {};
    get(row).forEach(function (c) { var id = bySw[c]; if (id) counts[id] = (counts[id] || 0) + 1; });
    /* Pièce en précommande : même propriété de ligne « Ships by » que le bloc précommande de la fiche. */
    var ship = row.dataset.ship;
    var items = Object.keys(counts).map(function (id) {
      var it = { id: Number(id), quantity: counts[id] };
      if (ship) it.properties = { 'Ships by': ship };
      return it;
    });
    if (!items.length) return;
    var body = { items: items };
    var ids = sectionIds();
    if (ids.length) { body.sections = ids; body.sections_url = location.pathname; }
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function (res) {
        return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { resource: cart, sourceId: 'bisous-complements', data: { sections: res.sections || {}, itemCount: cart.item_count } }
            }));
          });
      })
      .catch(function () { btn.textContent = 'Try again'; })
      .finally(function () { btn.removeAttribute('aria-busy'); btn.disabled = false; });
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('.bcc__sw');
    if (sw) {
      e.preventDefault();
      var row = sw.closest('[data-bcc-row]');
      var list = get(row);
      var qty = parseInt(row.dataset.qty, 10) || 1;
      list.push(sw.dataset.color);
      while (list.length > qty) list.shift();
      paint(row);
      return;
    }
    var btn = e.target.closest && e.target.closest('[data-bcc-add]');
    if (btn) {
      e.preventDefault();
      add(btn.closest('[data-bcc-row]'), btn);
    }
  });

  /* Le tiroir est redessine a chaque changement de panier : on repeint les nouvelles lignes. */
  new MutationObserver(function () { paintAll(); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { paintAll(); });
  else paintAll();
})();
